export function getCurrentUrl(): string {
  // In a browser environment, window.location.href gives the current URL
  return window.location.href;
}
